import type { App as VueApp } from "vue";
import { MotionPlugin } from "@vueuse/motion";
import InstantSearch from "vue-instantsearch/vue3/es";

export default (vueApp: VueApp) => {
  vueApp.use(MotionPlugin);
  vueApp.use(InstantSearch);

  //   vueApp.mount("#app");
};
